/**
 * Created by mac on 9/15/25
 */

// eslint-disable-next-line
var GeneratorDataProvider = function (orderManager) {
    this.generators = OrdersAlgoHelper.DefaultGenerators();
    this.lines = OrdersAlgoConfig.lines;

    this.orderManager = orderManager;

    this.pseudoRandom = PseudoRandom.GET("simpleAlgorithm");
};

GeneratorDataProvider.prototype.updatePseudoRandomSeed = function () {
    this.pseudoRandom.seed(this.orderManager.index);
};

GeneratorDataProvider.prototype.getPseudoRandom = function () {
    return this.pseudoRandom;
};

GeneratorDataProvider.prototype.howManyIngredients = function () {
    if (this.orderManager.index < 6) {
        return 1;
    }

    if (this.orderManager.index < 11) {
        return Math.floor(this.pseudoRandom.nextDouble() * 2) + 1;
    }

    return Math.floor(this.pseudoRandom.nextDouble() * 3) + 1;
};

GeneratorDataProvider.prototype.mapExistingItems = function () {
    const customers = Merge2.current.customers.listCustomersWithRecipe();

    const uniqes = {};
    customers.forEach((customer) => {
        const ingredients = customer.recipe.ingredients;
        ingredients.forEach((ingredient) => {
            if (!uniqes[ingredient.unit.code]) {
                uniqes[ingredient.unit.code] = {};
            }
            uniqes[ingredient.unit.code][ingredient.unit.stage] = true;
        });
    });

    return uniqes;
};

GeneratorDataProvider.prototype.getTargetVolume = function () {
    const indexes = Object.keys(GeneratorDataProvider.ALGO_VOLUMES);

    if (GeneratorDataProvider.ALGO_VOLUMES[this.orderManager.index]) {
        return GeneratorDataProvider.ALGO_VOLUMES[this.orderManager.index];
    }

    if (this.orderManager.index >= indexes[indexes.length - 1]) {
        return GeneratorDataProvider.ALGO_VOLUMES[indexes[indexes.length - 1]];
    }

    let i = 0;
    while (indexes[i] < this.orderManager.index) {
        i++;
    }
    const lower = indexes[i - 1];
    const upper = indexes[i];

    const lv = GeneratorDataProvider.ALGO_VOLUMES[lower];
    const uv = GeneratorDataProvider.ALGO_VOLUMES[upper];
    return Math.round(lv + (uv - lv) * (this.orderManager.index - lower) / (upper - lower));
};

GeneratorDataProvider.prototype.getCapLimit = function () {
    const capLimits = Object.keys(GeneratorDataProvider.ALGO_CAP_LIMITS).filter((stage) => this.orderManager.index < stage);
    return capLimits.length && GeneratorDataProvider.ALGO_CAP_LIMITS[capLimits[capLimits.length - 1]];
};

GeneratorDataProvider.prototype.getStagesFromLine = function (line) {
    const { minStage, maxStage: openMaxStage } = OrdersAlgoHelper.StageRange(line);
    let maxStage = openMaxStage;

    const generator = OrdersAlgoHelper.GeneratorForItem(line, this.generators);
    const stagesEnergy = [];
    for (let k = minStage; k <= maxStage; k++) {
        stagesEnergy.push(OrdersAlgoHelper.MinutesPerItem(line, k, generator));
    }

    const cupLimit = this.getCapLimit();
    if (cupLimit) {
        const limit = this.getTargetVolume();
        let rm = 0;
        for (let i = 0; i < 5; i++) {
            if (stagesEnergy.length === 1) {
                break;
            }
            if (stagesEnergy[stagesEnergy.length - 1] > limit * cupLimit) {
                stagesEnergy.pop();
                maxStage--;
                rm++;
            } else {
                break;
            }
        }

        if (rm > 0) {
            console.log(`${line} capping: ${limit} - ${rm}`, stagesEnergy);
        }
    }

    for (let i = 0; i < stagesEnergy.length; i++) {
        stagesEnergy[i] *= OrdersAlgoHelper.WeightForLine(line, generator);
    }

    return { minStage, maxStage, stagesEnergy };
};

GeneratorDataProvider.prototype.getOrderVolume = function (order) {
    let orderEnergy = 0;
    order.forEach((ingredient) => {
        const generator = OrdersAlgoHelper.GeneratorForItem(ingredient.line, this.generators);

        if (!generator) {
            return;
        }

        const energyPerItem = this.getEnergyForItem(ingredient.line, ingredient.stage) * OrdersAlgoHelper.WeightForLine(ingredient.line, generator);
        orderEnergy += energyPerItem;
    });

    return orderEnergy;
};

GeneratorDataProvider.prototype.getEnergyForItem = function (line, stage) {
    const generator = OrdersAlgoHelper.GeneratorForItem(line, this.generators);
    return OrdersAlgoHelper.MinutesPerItem(line, stage, generator);
};

GeneratorDataProvider.prototype.listLinesWithTargets = function () {
    const res = {};

    this.generators.forEach((generator) => {
        const stage = OrdersAlgoHelper.GeneratorStage(generator);

        if (!stage || !stage.drop) {
            return;
        }

        let drop = stage.drop;

        const generatorConfig = OrdersAlgoConfig.generators[generator.code];
        if (generatorConfig.algorithm && generatorConfig.algorithm.overrideDrop) {
            drop = generatorConfig.algorithm.overrideDrop;
        }

        const firstDrop = drop[0];
        res[firstDrop] = 1;

        const secondDrop = drop[1];
        if (secondDrop) {
            res[secondDrop] = 1;
        }
    });

    if (!res["a"]) {
        res["a"] = 1;
    }

    return res;
};

GeneratorDataProvider.ALGO_VOLUMES = {
    0: 60,
    7: 77,
    8: 105,
    50: 120,
    100: 135,
    150: 150,
    300: 240
};
GeneratorDataProvider.ALGO_CAP_LIMITS = {
    50: 4.1
};